import { Duration } from "../types";
import { ManipulateType } from "dayjs";

export const COLORS = {
  light_gray: "#f5f5f5",
  light_blue: "#1890ff",
  dark_red: "darkred",
  dim_gray: "dimgray",
  lime: "chartreuse",
  dark_green: "darkgreen",
  vibrant_green: "#069800",
  pastel_mint: "#7eff79",
  deep_crimson: "#980000",
  warm_tangerine: "#fdac4b",
  bright_lemon: "#f1fd4b",
  blue: "#0000FF",
  red: "#ff2c2c",
  grey: "#808080",
};

export const ENVS = {
  aws_region: process.env.REACT_APP_AWS_REGION || "",
  lambda_api_url: process.env.REACT_APP_LAMBDA_API_URL || "",
};

export const INTENTS = {
  // Property Management
  _add_property: "_add_property",
  _edit_property: "_edit_property",
  _remove_property: "_remove_property",

  // Building Management
  _add_building: "_add_building",
  _edit_building: "_edit_building",
  _remove_building: "_remove_building",

  // Unit Management
  _add_unit: "_add_unit",
  _edit_unit: "_edit_unit",
  _remove_unit: "_remove_unit",

  // Lease Management
  _add_lease: "_add_lease",
  _delete_lease: "_delete_lease",
  _terminate_lease: "_terminate_lease",
  _advance_lease: "_advance_lease",
  _cancel_lease_actions: "_cancel_lease_actions",
  _submit_lease_application: "_submit_lease_application",
  _sign_offer: "_sign_offer",
  _renew_lease: "_renew_lease",
  _agree_to_renewal: "_agree_to_renewal",

  // Tenant Management
  _add_tenant: "_add_tenant",
  _submit_background_check_info: "_submit_background_check_info",

  // Payment & Finance
  _make_payment: "_make_payment",
  _terminate_transaction: "_terminate_transaction",
  _complete_payment: "_complete_payment",
  _rent_paid: "_rent_paid",
  _rent_lost: "_rent_lost",
  _view_transaction_receipt: "_view_transaction_receipt",

  // Service Requests
  _add_service_request: "_add_service_request",
  _edit_service_request: "_edit_service_request",
  _remove_service_request: "_remove_service_request",
  _update_request_status: "_update_request_status",

  // Amenity Management
  _amenity_create_reservation: "_amenity_create_reservation",
  _edit_amenity_reservations_cancel: "_edit_amenity_reservations_cancel",

  // User Authentication & Management
  _signup: "_signup",
  _signin: "_signin",
  _google_signup: "_google_signup",
  _google_signin: "_google_signin",
  _invite_user: "_invite_user",
  _shadow_invite_claim: "_shadow_invite_claim",

  // File Management
  _upload_file: "_upload_file",
  _get_upload_url: "_get_upload_url",
  _delete_file: "_delete_file",
  _remove_all_files_for_entity: "_remove_all_files_for_entity",

  // Communication
  _add_comment: "_add_comment",
  _prepare_review_email: "_prepare_review_email",
  _send_mail: "_send_mail",

  // System
  _refresh: "_refresh",
};

export const DAYS_OF_WEEK_DB = {
  sunday: "U",
  monday: "M",
  tuesday: "T",
  wednesday: "W",
  thursday: "H",
  friday: "F",
  saturday: "A",
};

export const ROUTES = {
  amenity: "/amenity",
  amenityDetails: "/amenity/:amenityID",
  amenityReservation: "/amenity/:amenityID/reservation",
  backgroundCheck: "/background-check",
  buildingDetails: "/building/:buildingID",
  contactManagementPage: "/contact-management",
  financePage: "/finance",
  help: "/help",
  home: "/",
  lease: "/lease",
  leaseApplication: "/lease-application/:entityType/:entityID",
  leaseDetails: "/lease/:leaseID",
  leaseRenewalPage: "/lease-renewal",
  messageDetails: "/messages/:messageID",
  messageTablePage: "/message",
  myDocumentsPage: "/my-documents",
  paymentsPage: "/payments/new",
  paymentTablePage: "/payments",
  propertyDetails: "/property/:propertyID",
  reviewPage: "/reviewpage",
  serviceRequestDetails: "/service-request/:requestID",
  serviceRequestNew: "/service-request/new",
  serviceRequestTablePage: "/service-request",
  signup: "/signup",
  /** Review shadow-tenant invite (lease / unit / docs) before sign-in */
  shadowInvite: "/shadow-invite",
  unauthorized: "/unauthorized",
  unit: "/unit",
  unitDetails: "/unit/:unitID",
  unitPlanDetails: "/unit/plan/:planID",
};

// Do not translate
export const durationToDayjs = (
  duration: Duration,
): ManipulateType | undefined => {
  switch (duration) {
    case Duration.Second:
      return "second";
    case Duration.Minute:
      return "minute";
    case Duration.Hour:
      return "hour";
    case Duration.Day:
      return "day";
    case Duration.Week:
      return "week";
    case Duration.Month:
      return "month";
    case Duration.Year:
      return "year";
  }
};
